<template>
  <div class="manager-certificate">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
      <!-- <query-assembly @getList="getList"></query-assembly> -->
    </action-bar>
    <normal-table ref="commonTable" :table-col="tableCol" :table-data="list" :first-table-col="firstTableCol"
      :operator="operator" :operate-col="operateCol" :show-edit="true" :paging="paging" 
      @pagination="handleSizeOrPageChange">
    </normal-table>
    <gen-manager-cert ref="genManagerCert" @update:list="getList()"></gen-manager-cert>
    <show-cert-dialog ref="seeDialog"></show-cert-dialog>
  </div>
</template>

<script>
import auth from '@/auth/index'
import genManagerCert from './components/genManagerCert'
import showCertDialog from './components/showCertDialog'
export default {
  name: 'ManagerCerts',
  components: {
    genManagerCert,
    showCertDialog
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '生成管理员证书',
          click: () => {
            return this.genManagerCert()
          },
          auth: auth.certificate.publicKeyAuth.adminCert.createAdminCert,
          icon: 'icon-gen'
        }
      ],
      // 设置table的列
      tableCol: [
        { 
          prop: 'AdminID', 
          label: '管理员ID',
          minWidth: 217,  
        },
        { 
          prop: 'AdminName', 
          label: '管理员名称',
          minWidth: 186,  
        },
        {
          prop: 'AuthType',
          label: '认证模式',
          minWidth: 188,
          formatter: row => {
            return this.formatAuthType(row.AuthType)
          }
        },
        {
          prop: 'PubKeyAlgo',
          label: '密码算法',
          minWidth: 174,
          formatter: row => {
            return this.formatAlgo(row.PubKeyAlgo)
          }
        },
        {
          prop: 'createAt',
          label: '创建时间',
          minWidth: 244,
          formatter: row => {
            return this.formatTime(row)
          }
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看公钥',
          showText: true,
          click: (row, col, cellValue) => {
            return this.getInfo(row, col, cellValue)
          },
          icon: 'icon-check'
        },
        {
          text: '下载',
          showText: true,
          click: (row, col, cellValue) => {
            return this.downloadFile(row)
          },
          icon: 'icon-download'
        }
      ],
      operateCol: {
        minWidth: 158
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      },
      list: [],
      paging: {
        offset: 0,
        limit: 10,
        total: 0,
        totalPages: 0
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(limit = 10, offset = 0, name) {
      let params = {
        offset,
        limit, 
        name
      }
      let self = this;
      this.$apis.certificate
        .getDposManagerCerts(params)
        .then(response => {
          if(response && response.data){
            self.list = response.data.items;
            self.paging.limit = response.data.limit;
            self.paging.offset = response.data.offset;
            self.paging.total = response.data.total;
            self.paging.totalPages =  Math.ceil(self.paging.total /  self.paging.limit);
          }
        })
        .catch(error => Promise.reject(error))
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data 
      this.getList(limit, offset * limit)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    formatAlgo(algo) {
      switch (algo) {
        case 0:
          return '国密'
        case 1:
          return 'ECDSA'
        default:
          return this.$constants.EMPTY
      }
    },
    formatAuthType(type) {
      return 'public'
    },
    genManagerCert() {
      this.$refs.genManagerCert.handleOpen()
    },
    //查看公钥方法
    getInfo(row, col, cellValue) {
      let data = {
        cert: row.PublicKey,
        title: '查看公钥',
        downloadName: row.AdminName,
        top: '25vh'
      }
      this.$refs.seeDialog.handleOpen(data)
    },
    downloadFile(row) {
      const name = row.AdminName + '.key'
      this.$utils.createFileAndDownload(name, row.PublicKey)
    },
    refresh() {
      const { offset, limit } = this.paging
      this.getList(limit, offset)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.manager-certificate {
  @include adaptation(
    (
      --manager-certificate-list-unavailable-height: 111px,
    )
  );
  --manager-certificate-list-min-height: calc(var(--base-main-router-body-avaliable-height) - var(--manager-certificate-list-unavailable-height));

  .normal-table-wrap {
    height: 100%;
    min-height: var(--manager-certificate-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--manager-certificate-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--manager-certificate-list-min-height);
      }
    }
  }
}
</style>
